import SearchActionTypes from '../types/search';

const SearchReducer = function(/*state, action*/) {
  var defaultState = { userIds: [], userNames: [] };
  var state = arguments.length <= 0 || arguments[0] === undefined ? defaultState : arguments[0];
  var action = arguments[1];
  var store = Object.assign(defaultState, state);

  switch (action.type) {
    case SearchActionTypes.RECEIVE_SEARCH_RESULTS:
      var userIds = action.userIds;
      var userNames = action.userNames;

      return Object.assign({}, {userIds: userIds, userNames: userNames});;
  }

  return state;
};

export default SearchReducer;
